<template>
  <div class="field-checkbox field-checkbox_with-bg">
    <input class="field-checkbox__input"
           type="checkbox"
           id="subscription"
           value="value"
           v-model="checked"
    >
    <label class="field-checkbox__label" for="subscription">Получение информационной рассылки от&nbsp;Boxberry</label>
  </div>
</template>
<script>
  export default {
    name: 'CheckboxSubscription',
    data() {
      return {
        checked: false,
      }
    },
    updated() {
      this.$emit('checkedSubscription', this.checked);
    },
  }
</script>
